export default "__VITE_ASSET__CRGlNsod__"